var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.45 20.25C21.65 20.45 21.65 20.75 21.45 20.95C21.35 21.05 21.2 21.1 21.1 21.1C21 21.1 20.85 21.05 20.75 20.95L16.55 16.75L12.35 20.95C12.25 21.05 12.1 21.1 12 21.1C11.9 21.1 11.75 21.05 11.65 20.95C11.45 20.75 11.45 20.45 11.65 20.25L15.85 16.05L11.65 11.85C11.45 11.65 11.45 11.35 11.65 11.15C11.85 10.95 12.15 10.95 12.35 11.15L16.55 15.35L20.75 11.15C20.95 10.95 21.25 10.95 21.45 11.15C21.65 11.35 21.65 11.65 21.45 11.85L17.25 16.05L21.45 20.25Z",
    fill: "#CC7722"
  })));
};
export default SvgClose;